// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isInfobipKakaoSenderKeysResult = objectOf({
  hits: number,
  error: maybe(string),
  message: maybe(string),
  results: arrayOf(
    objectOf({
      id: string,
      provider: string,
      api_key: string,
      url: string,
      channel_uuid: string,
      channel_name: string,
      sender_key: string,
    })
  ),
});
